(() => {
  if (window.sealTidioChatLauncherInitialized) return;
  window.sealTidioChatLauncherInitialized = true;

  const tidioZIndex = '2147483647';
  const tidioOpenClass = 'tidio-chat-is-open';
  let tidioContainer;
  let tidioEventListenersInitialized = false;

  const initializeTidioEventListeners = () => {
    if (!window.tidioChatApi || tidioEventListenersInitialized) return;

    tidioEventListenersInitialized = true;
    window.tidioChatApi.on('open', () => {
      document.documentElement.classList.add(tidioOpenClass);
    });
    window.tidioChatApi.on('close', () => {
      document.documentElement.classList.remove(tidioOpenClass);
    });
  };

  if (window.tidioChatApi) {
    initializeTidioEventListeners();
  } else {
    document.addEventListener('tidioChat-ready', initializeTidioEventListeners, { once: true });
  }

  const tidioStyleObserver = new MutationObserver(() => {
    if (
      tidioContainer.style.getPropertyValue('z-index') !== tidioZIndex ||
      tidioContainer.style.getPropertyPriority('z-index') !== 'important'
    ) {
      tidioContainer.style.setProperty('z-index', tidioZIndex, 'important');
    }
  });

  const lowerTidioZIndex = () => {
    const container = document.getElementById('tidio-chat');
    if (!container) return;

    if (container !== tidioContainer) {
      tidioStyleObserver.disconnect();
      tidioContainer = container;
      tidioStyleObserver.observe(tidioContainer, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    if (
      tidioContainer.style.getPropertyValue('z-index') !== tidioZIndex ||
      tidioContainer.style.getPropertyPriority('z-index') !== 'important'
    ) {
      tidioContainer.style.setProperty('z-index', tidioZIndex, 'important');
    }
  };

  const tidioDomObserver = new MutationObserver(lowerTidioZIndex);
  tidioDomObserver.observe(document.documentElement, { childList: true, subtree: true });
  lowerTidioZIndex();

  const openChat = () => {
    if (!window.tidioChatApi) return false;

    if (typeof window.tidioChatApi.show === 'function') {
      window.tidioChatApi.show();
    }

    if (typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
      return true;
    }

    return false;
  };

  document.addEventListener('click', (event) => {
    const launcher = event.target.closest('[data-tidio-chat-open], a[href="#tidio-chat"]');
    if (!launcher) return;

    if (!openChat()) return;

    event.preventDefault();
  });
})();
